<template>
  <v-main>
    <PageWrapper class="pa-0">
      <PageContent>
        <div class="mb-2 btn-new"> 
          <v-btn
            color="#27997c"
            dark
            class="mb-2"
            @click="openDialog = !openDialog"
            v-on="on"
          >
          <v-icon>mdi-plus</v-icon>  
            Adicionar Novo
          </v-btn>
        </div>
        <v-data-table
        :headers="headers"
        :items="getList"
        :loading="loading"
        :search="search"
          class="elevation-1"
        >
          <template v-slot:top>
            <v-toolbar
              flat
            >
              <v-toolbar-title>Listagem de Unidades</v-toolbar-title>
              <v-divider
                class="mx-4"
                inset
                vertical
              ></v-divider>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                dense
                outlined
                label="Buscar"
                append-icon="mdi-magnify"
              ></v-text-field>
                  
            </v-toolbar>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon
              color="warning"
              small
              class="mr-2"
              @click="editItem(item)"
            >
              mdi-pencil
            </v-icon>
            <v-icon
              color="red"
              small
              @click="deleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </template>
          <template v-slot:no-data>
            <span>Sem dados disponíveis</span>
        </template>
        </v-data-table>
        <AddModalVue :openDialog="openDialog" @closeModal="closeModal" />
        <EditModal :objValue="objEdit" :dialogEdit="dialogEdit" @closeEditItem="closeEditItem" />
        <DeleteModal :dialogDelete="dialogDelete" :objValue="objEdit" @deleteItemConfirm="deleteItemConfirm" @closeDelete="closeDelete" />
      </PageContent>
    </PageWrapper>
  </v-main>
</template>

<script>
import PageWrapper from '@/components/template/PageWrapper.vue';
import PageContent from '@/components/template/PageContent.vue';
import { mapGetters, mapActions } from 'vuex';
import AddModalVue from './AddModal.vue'
import EditModal from './EditModal.vue'
import DeleteModal from './DeleteModal.vue'
  export default {
    components:{
    PageWrapper,
    PageContent,
    AddModalVue,
    EditModal,
    DeleteModal
  },
    data: () => ({
      search:'',
      openDialog: false,
      dialogEdit:false,
      dialogDelete: false,
      loading:false,
      objEdit:{},
      headers: [
        { text: 'Nome', value: 'nome',  sortable: false,  align: 'start', },
        {
          text: 'Descrição',
          align: 'start',
          sortable: false,
          value: 'descricao',
        },
        {
          text: 'Número de ART',
          align: 'start',
          sortable: false,
          value: 'art',
        },
        { text: 'Ações', value: 'actions', sortable: false, align: 'start',}
      ],
      obras: [],
      editedIndex: -1,
    }),
    computed: {
      ...mapGetters('obra',['getList']),
    },
    async created () {
       await this.getAllObras ()
    },
    methods: {
      ...mapActions('obra', ['getAllObras']),
      initialize () {
        this.obras = ['']
      },
      deleteItem (item) {
        this.objEdit = Object.assign({}, item)
        this.dialogDelete = true
      },
      deleteItemConfirm () {
        this.getList.splice(this.editedIndex, 1)
        this.closeDelete()
      },
      editItem (item) {
          this.objEdit = Object.assign({}, item)
          this.dialogEdit = true
        },
     // edit (item) {
     //   this.dialogEdit = true
     //   this.objEdit = item
     // },
      closeDelete () {
         this.dialogDelete = false;
      },
      closeEditItem () {
         this.dialogEdit = false;
      },
      closeModal () {
        this.openDialog = false;
      },
      close () {
        this.dialog = true
        /*this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem)
            this.editedIndex = -1
        })*/
      },
    },
  }
</script>

<style>

.menu {
  width: 80%;
  padding-top: 70px;
  position: absolute;
}
.btn-new{
  margin-right: 24px;
  padding-top: 10px;
  justify-content: flex-end;
  display: flex;
}
.title-card{
  background: #272727;
  color: white;
  padding: 20px !important;
}
.v-card__text {
  padding-top: 20px !important;
}
</style>